import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Facet, locationCollectionResponse, LocationList } from 'src/app/models/walai';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-more-filter-dialog',
  // standalone: true,
  // imports: [],
  templateUrl: './more-filter-dialog.component.html',
  styleUrl: './more-filter-dialog.component.css'
})
export class MoreFilterDialogComponent implements OnInit {
  @Input() filters: Array<Facet> = [];
  @Input() filterName: string = '';
  sortOption: 'alphabetical' | 'count' = 'alphabetical';

  filters2: Array<Facet> = [];
  locationList: LocationList[] = [];
  locationCollectionData: locationCollectionResponse[] = [];


  constructor(
    public activeModal: NgbActiveModal,
    private homeService: HomeService
  ) {
    // Initialize the filters if not provided

  }

  ngOnInit(): void {
    if (this.filterName.toLowerCase() === 'location') {
      this.getLocation();

    }
    else if (this.filterName.toLowerCase() === 'collection') {
      if (localStorage.getItem('locationCollectionResponse') != null) {
        this.locationCollectionData = JSON.parse(localStorage.getItem('locationCollectionResponse'));
      }
      this.getCollection();
    }
    else {
      this.filters2 = this.filters;
      this.sortFilters();
    }



  }

  // get collection
  getCollection() {


    this.filters2 = this.filters.map((item: Facet) => {
      return {
        ...item,
        name: this.getCollectionDisplayName(item.name)
      }
    })



    this.sortFilters();

  }

  getCollectionDisplayName(name: string): string {

    if (!this.locationCollectionData || this.locationCollectionData.length === 0) {
      return name;
    }

    for (const location of this.locationCollectionData) {
      if (location.collections) {
        const found = location.collections.find(c => String(c.Value) === String(name));
        if (found) {
          return found.DISPLAY;
        }
      }
    }
    return name;
  }

  // get locatios
  getLocation() {
    this.homeService.getLocation().subscribe((res: LocationList[]) => {
      this.locationList = res;
      this.filters2 = this.filters.map((item: Facet) => {
        return {
          ...item,
          name: this.locationList.find((location: LocationList) => location.LOCATIONID.toString() === item.name)?.LOCATIONNAME || item.name
        }
      })
      this.sortFilters();

    });
  }




  changeSortOption(option: 'alphabetical' | 'count'): void {
    this.sortOption = option;
    this.sortFilters();
  }

  sortFilters(): void {
    if (this.sortOption === 'alphabetical') {
      this.filters2.sort((a, b) => a.name.localeCompare(b.name));
    } else if (this.sortOption === 'count') {
      this.filters2.sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0));
    }

  }

  // Click event handler  และส่งค่ากลับไปยัง parent component
  onFilterClick(filter: Facet): void {
    if (this.filterName.toLowerCase() === 'location') {
      filter.name = this.locationList.find((location: LocationList) => location.LOCATIONNAME === filter.name)?.LOCATIONID.toString() || filter.name
    }
    else if (this.filterName.toLowerCase() === 'collection') {
      let foundValue = filter.name;
      for (const loc of this.locationCollectionData) {
        const col = loc.collections?.find(c => c.DISPLAY === filter.name);
        if (col) {
          foundValue = col.Value.toString();
          break;
        }
      }
      filter.name = foundValue;
    }


    this.activeModal.close(filter);
  }


}